import { z } from "zod";

import { Funder, Proposal, Recommender } from "@engine/round/aggregate";
import { RoundMember, User } from "database";

export type Evaluable = Recommender | Proposal;
export type Evaluator = Recommender | Funder;

export const trackSchema = z.enum(["FREEDOM", "FAIRNESS", "MAIN", "NO_TRACK"]);

export const trackNames: Record<Track, string> = {
  MAIN: "Main",
  FAIRNESS: "Fairness",
  FREEDOM: "Freedom",
  NO_TRACK: "No Track",
};

export type Track = z.infer<typeof trackSchema>;

export type UserProfile = Omit<User, "sub"> & { track: RoundMember["track"] };

export type UserProfiles = {
  [userId: string]: UserProfile;
};
